<template>
  <div class="all-catalog">
    <div
      class="all-catalog-list"
      :class="{'all-catalog-list--loading': loading}"
      v-show="rendered"
    >
      <div
        id="prev-page-button"
        class="all-catalog-more all-catalog-more--top all-catalog-more--top-no-offset"
        :class="{'all-catalog-more--loading': loadMoreLoading}"
        v-show="listLoaded"
        v-if="!!page"
      >
        <button @click="loadPrev" type="button" class="btn">
          Загрузить предыдущие
        </button>
      </div>
      <div class="g-grid-row" v-if="listLoaded && list.length">
        <div
          class="g-grid-col g-grid-col--33"
          :class="item.first ? 'list-page-' + item.page : ''"
          v-for="(item, index) in list"
          :key="index"
          @click="savePosition(item)"
          v-html="item.html"
        ></div>
      </div>
      <div class="messages messages--warning" v-else-if="listLoaded" v-show="rendered">
        К сожалению, видео нет.
      </div>
      <div
        class="all-catalog-more"
        :class="{'all-catalog-more--loading': loadMoreLoading}"
        v-show="listLoaded"
        v-if="list.length"
      >
        <div class="all-catalog-more-bar">
          <div class="all-catalog-more-bar-label">
            Вы просмотрели {{ watched }} из {{ total }} видео
          </div>
          <div class="all-catalog-more-bar-body">
            <div class="all-catalog-more-bar-progress" :style="'width: ' + progress + '%'"></div>
          </div>
        </div>
        <button @click="loadMore" type="button" class="btn" v-if="total > watched">
          Показать еще
        </button>
        <pagination
          v-if="pages > 1"
          v-model="page"
          :page-count="pages"
          :click-handler="gotoPage"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Video',
  props: {
    startPage: Number,
  },
  data() {
    return {
      list: [],
      message: '',
      currentPath: window.location.pathname,
      page: 0,
      pages: 0,
      total: 0,
      watched: 0,
      progress: 0,
      nextPageScroll: 0,
      firstRun: true,
      loading: false,
      rendered: false,
      listLoaded: false,
      loadMoreLoading: false,
      nav: {
        up: false,
        down: false,
      },
    }
  },
  methods: {
    getList(method) {
      if (method !== 'merge') {
        this.loading = true;
      }

      let params = {
        params: {
          page: this.page,
        }
      };

      if (!this.firstRun) {
        this.updateUrl();
      }
      else {
        params.params.startPage = this.startPage;
      }

      axios.get('/video/get', params).then(response => {
        if (method === 'merge') {
          this.list = this.list.concat(response.data.list);
        }
        else if (method === 'before') {
          this.list = response.data.list.concat(this.list);
        }
        else {
          this.list = response.data.list;
        }
        if (this.firstRun) {
          this.checkPositionCookie();
        }
        this.total = response.data.total;
        this.pages = response.data.pages;
        this.watched = response.data.watched ? response.data.watched : this.watched;
        this.loading = false;
        this.listLoaded = true;
        this.loadMoreLoading = false;
        this.progress = (this.watched / this.total) * 100;
        this.firstRun = false;
        if (method === 'before') {
          this.scrollToPrevPage();
        }
        else if (method === 'merge') {
          this.scrollToNextPage();
        }
      }).catch(() => {
        this.message = 'Произошла ошибка №1, пожалуйста, сообщите об ошибке на адрес zakaz@garshinka.ru.';
        this.loading = false;
        this.loadMoreLoading = false;
      });
    },
    loadMore() {
      if (this.total > this.list.length) {
        if (this.nav.down !== false) {
          this.page = this.nav.down;
          this.nav.down = false;
        }
        else {
          this.page++;
        }
        this.loadMoreLoading = true;
        window.$cookies.remove('lastViewItem');
        this.nextPageScroll = window.scrollY;
        this.getList('merge');
      }
    },
    loadPrev() {
      if (this.page !== 0) {
        if (this.nav.down === false) {
          this.nav.down = this.page + 1;
        }
        if (this.nav.up !== false) {
          this.page = this.nav.up;
          this.nav.up = false;
        }
        else {
          this.page--;
        }
        this.loadMoreLoading = true;
        window.$cookies.remove('lastViewItem');
        this.getList('before');
      }
    },
    scrollToNextPage() {
      if (!this.nextPageScroll) {
        return;
      }

      let times = 0;
      var that = this;

      requestAnimationFrame(function measure(time) {
        window.scrollTo({
          top: that.nextPageScroll,
        });

        if (times++ < 10) {
          requestAnimationFrame(measure);
        }
        else {
          that.nextPageScroll = 0;
        }
      })
    },
    scrollToPrevPage() {
      let element = document.querySelector('.list-page-' + (this.page + 1));
      let rowOffset = element.getBoundingClientRect().top;
      setTimeout(() => {
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }
        let offset = window.pageYOffset;
        element.scrollIntoView();
        window.scrollTo(0, window.pageYOffset - rowOffset);
      }, 1);
    },
    updateUrl() {
      let url = window.location.origin + window.location.pathname + '?page=' + this.page;
      window.history.pushState('', '', url);
    },
    applyInputPage() {
      if (this.startPage) {
        this.page = this.startPage;
        this.nav.up = this.page - 1;
      }
    },
    gotoPage(page) {
      this.page = page - 1;
      this.nav.up = false;
      this.scrollToTop();
      this.getList('no-merge');
    },
    scrollToTop() {
      if (window.pageYOffset < (window.innerHeight / 2)) {
        return;
      }
      const OFFSET = document.getElementById('block-adaptive-content').offsetTop;
      const start = window.pageYOffset;
      const change = OFFSET - start;
      const increment = 20;
      const duration = 600;
      let currentTime = 0;

      const animateScroll = (() => {
        currentTime += increment;
        document.documentElement.scrollTop = Math.easeInOutQuad(currentTime, start, change, duration);
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      });

      animateScroll();
    },
    savePosition(item) {
      let cookie = {
        id: item.id,
        page: this.page,
      };
      window.$cookies.set('lastViewItem', JSON.stringify(cookie), '10m');
    },
    checkPositionCookie() {
      let cookie = window.$cookies.get('lastViewItem');
      if (!cookie) {
        return;
      }

      if (this.page !== cookie.page) {
        return;
      }
      setTimeout(() => {
        let element = document.getElementById(cookie.id);
        if (!element) {
          return;
        }
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }
        element.scrollIntoView();
        window.$cookies.remove('lastViewItem');
      }, 10);
    },
  },
  created() {
    this.rendered = true;
    this.applyInputPage();
    this.getList('no-merge');
  }
}
</script>
